import axiosServer from "../../axios/axiosServer";
import APIs from "../../constant/endpoint";

export const createPayment = async (data) => {
  const res = await axiosServer.post(APIs.createPayment, data);
  return res.data;
};

export const getHistoryPayment = async (props, pageSize, userId) => {
  const res = await axiosServer.get(APIs.getHistoryPayment, {
    params: { page: props.pageParam, pageSize, userId },
  });
  return res.data;
};

export const getVipRewardStatus = async (data) => {
  const res = await axiosServer.post(APIs.getVipRewardStatus, data);
  return res.data;
};

export const buyVip = async (data) => {
  const res = await axiosServer.post(APIs.buyVip, data);
  return res.data;
};

export const updatePaymentOrderStatus = async (data) => {
  const res = await axiosServer.post(APIs.updatePaymentOrderStatus, data);
  return res.data;
};

export const getVipOrder = async (userId) => {
  const res = await axiosServer.get(APIs.getVipOrder, {
    params: userId,
  });
  return res.data;
};

export const updateVip = async (data) => {
  const res = await axiosServer.post(APIs.updateVipOrder, data);
  return res.data;
};

// Legacy Payment PayOS QR (keeping for backward compatibility)
export const createPaymentPayOS = async (data) => {
  const res = await axiosServer.post(APIs.createPaymentPayOS, data);
  return res.data;
};

export const cancelPaymentPayOS = async (data) => {
  const res = await axiosServer.post(APIs.cancelPayOSPaymentOrder, data);
  return res.data;
};

// ==================== NEW AUTO PAYMENT QR ====================
// Create QR Payment Order
export const createQRPayment = async (data) => {
  const res = await axiosServer.post(APIs.createQRPayment, data);
  return res.data;
};

// Check payment status (for polling)
export const checkPaymentStatus = async (orderId) => {
  const res = await axiosServer.get(APIs.checkPaymentStatus, {
    params: { orderId },
  });
  return res.data;
};

// Cancel QR payment
export const cancelQRPayment = async (data) => {
  const res = await axiosServer.post(APIs.cancelQRPayment, data);
  return res.data;
};
